import classes from './style/layout.module.css'
import img from '../img/wave.svg'
import pic from '../img/pic.JPG'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
const Layout = () => {
    return (
        <div className={classes.layout}>
            <div className={classes.container}>
                <div className={classes.pic}>
                    <img src={pic} alt='' />
                </div>
                <div className={classes.text}>
                    <h2>Hello World! </h2>
                    <h1> I'm Yosef Adel</h1>
                    <div className={classes.animatedText}>
                        <h2>Computer engineering student at Cairo university</h2>
                        <h2>International student at SJSU</h2>
                        <h2>Full stack developer</h2>
                    </div>
                    <div className={classes.con} >
                        <a className={classes.icon} href="https://www.linkedin.com/in/yosef-adel-46057b21a" target="_blank" rel="noreferrer">
                            <p><LinkedInIcon style={{ fontSize: 40 }} /></p>

                        </a>

                        <a className={classes.icon} href='https://github.com/Yosef-Adel' target="_blank" rel="noreferrer">
                            <p> <GitHubIcon style={{ fontSize: 40 }} /> </p>

                        </a>
                    </div>
                </div>
            </div>
            <div className='wave'>
                <img src={img} alt="wave" />
            </div>


        </div>
    )
}

export default Layout
